import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { EbDashboardEmployeeBasicInfoVm } from '../../model/eb-dashboard-employee-basic-info-vm';

@Component({
  selector: 'app-eb-dashboard-employee-basic-info',
  templateUrl: './eb-dashboard-employee-basic-info.component.html',
  styleUrls: ['./eb-dashboard-employee-basic-info.component.scss']
})
export class EbDashboardEmployeeBasicInfoComponent implements OnInit, OnChanges  {
  @Input() employeeBasicInfo: EbDashboardEmployeeBasicInfoVm;
  @Input() enrolId: number;
  constructor() { }
  ngOnInit() {
    
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    this.employeeBasicInfo = changes.employeeBasicInfo.currentValue;
  }

}
